import React from "react";

export const PageImageGalleryPanel = ({ children }: { children?: React.ReactNode }) => {
  return <div className="gallery-panel">{children}</div>;
};

(PageImageGalleryPanel as any).craft = {
  props: {},
  related: {
    settings: () => <div>Panel Settings</div>
  }
};
